export default __webpack_public_path__ + "static/media/39_padik.667888a4.JPG";